module.exports = __webpack_public_path__ + "components/rewards/offline-maps/static/logo-8e110a8e141192798a30bd9a84bda080.jpg";